import React, { useState } from 'react';
import { useParams, useLocation, useHistory } from 'react-router';
import { isEmpty } from 'ramda';
import { useManagedQuery } from 'utils/managedHooks';
import { GET_BOOKING } from 'store/queries';
import AddAssistance from 'components/shared/AddAssistance';
import { Spinner } from 'admin-components/components';
import { Column, Page, Row } from 'components/shared/Layout';
import Button, { CancelButton } from 'components/ui/Button';
import { FormattedMessage } from 'react-intl';
import { ChevronRight } from 'react-feather';
import { StyledCancelButton } from './index.styles';

const Index = () => {
  const history = useHistory();
  const location = useLocation();
  const { reference } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);
  const showExtras = location.pathname.includes('/extras/manage');
  const showAssistance = location.pathname.includes('/assistance/add');
  const passengerId = new URLSearchParams(location.search).get('passengerId');

  const { loading, data, refetch } = useManagedQuery(GET_BOOKING, {
    variables: { reference }
  });

  if (loading) {
    return (
      <Column alignItems="center" justifyContent="center">
        <Spinner />
      </Column>
    );
  }

  return (
    <Page>
      <Row start={2} span={14}>
        <AddAssistance
          bookingData={data.booking}
          refetchBooking={refetch}
          setLoading={setLoading}
          setIsConfirmDisabled={setIsConfirmDisabled}
          showExtras={showExtras}
          showAssistance={showAssistance}
          shouldConfirmBooking={!showExtras}
          shouldUseReviewBookingScreen
          isReturn={!isEmpty(data.booking.eurostarOutbound) && !isEmpty(data.booking.eurostarInbound)}
          passengerId={passengerId}
        />

        <div>
          <Button
            type="submit"
            loading={isLoading}
            disabled={isConfirmDisabled}
            data-cy="bp-continue"
            form="add-assistance-form"
            variant="primary"
          >
            <FormattedMessage id={showExtras ? 'bookingPath.continue' : 'bookingPath.addAssistance'} />
            <ChevronRight />
          </Button>
          <StyledCancelButton>
            <CancelButton
              onClick={() =>
                showExtras ? history.push(`/manage/bookings/${reference}/extras`) : history.push(`/manage/bookings/${reference}/assistance`)
              }
              type="button"
            >
              <FormattedMessage id="payments.cancel" />
            </CancelButton>
          </StyledCancelButton>
        </div>
      </Row>
    </Page>
  );
};

export default Index;
